import axios from 'axios'
import { clearTokens, getAccessToken } from '@/lib/tokenStorage'
import { saveRedirect } from '@/lib/redirectStorage'
import { getOrCreateUUID } from '@/lib/uuid'

export const apiClient = axios.create({ baseURL: '/api' })

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken()
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  } else {
    config.headers['X-User-UUID'] = getOrCreateUUID()
  }
  return config
})

apiClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      clearTokens()
      // ハード遷移で state が消えるため、戻り先を sessionStorage に退避してから飛ばす。
      const { pathname, search } = window.location
      if (pathname !== '/login') {
        saveRedirect(pathname + search)
      }
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)
